import paymentInstance from '../../instance'
import paymentModalLoginInstance from '../../modalLoginInstance'

const createTap2PayPaymentSession = ( totalSum, paymentSource, hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).post('tap2pay/paymentSessions', { totalSum, paymentSource })
}

export default createTap2PayPaymentSession
